import { Transform } from 'class-transformer';
import { dateTransformer } from 'src/lib/utilities/api/class-transformer-types';
import { AbstractPerformanceRequirementProof } from './abstract-performance-requirement-proof.model';

export class MeetupPerformanceRequirementProof extends AbstractPerformanceRequirementProof {
	minutes: number;
	@Transform(dateTransformer)
	date: Date;
}
